// extracted by mini-css-extract-plugin
export default {"SectionBlock":"SectionBlock_SectionBlock__H2btx","SectionHeader":"SectionBlock_SectionHeader__TlyGH"};